import useToast from '@hooks/ui/useToast';
import { getContacts, Permission, requestPermission } from '@utils/nativeUtils';

import useNativeListener from './useNativeListener';

interface Props {
    callbackFn?: (name: string, phone: string) => void;
    errorMessage: string;
}

function useGetContact({ callbackFn, errorMessage }:Props) {
    const openContacts = () => {
        requestPermission(Permission.READ_CONTACT);
    };
    const toast = useToast();

    useNativeListener('requestPermission', (permission: Permission, result: boolean) => {
        if (permission === Permission.READ_CONTACT) {
            if (result) {
                getContacts();
            } else {
                toast.error(errorMessage);
            }
        }
    }, [errorMessage]);

    useNativeListener('setContacts', (name: string, phone: string) => {
        callbackFn?.(name, phone);
    }, [callbackFn]);

    return {
        openContacts,
    };
}

export default useGetContact;
